module.exports = __webpack_public_path__ + "static/media/Polygon 1.ae1f8ad7.svg";